import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { toaster } from 'rsuite';
import toastMessage from '../../../components/ToastMessage';
import { errorHandler } from '../../../utils/newApplicationUtils';
import { merchantActionTypes } from '../action-types';
import { CheckoutFieldsReturnTypes, convertToCheckoutInitial } from '../../../constants/merchant/checkout-form';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { IWidget } from '../../../constants/widget-configuration/widget-configuration-form';

export const fetchWidgetConfigurationData = async (dispatch: React.Dispatch<IAction>, siteId: string, mid: string = ''): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_WIDGET_CONFIGURATIONS_LOADING });
		const res = await axios.get(`${BASE_URL.TRACKING}/configuration/${mid}/widget/${siteId}`);
		if (res?.data) {
			dispatch({ type: merchantActionTypes.FETCH_WIDGET_CONFIGURATION_DATA, payload: res.data });
		}
	} catch (e) {
		Sentry.setTag('fetch-widget-config-siteId', siteId);
		Sentry.setTag('fetch-widget-config-mid', mid);
		sendSentryMessage({ name: `GET Fetch widget configuration error`, context: e });
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const setWidgetConfigurations = async (id: string, params: IWidget): Promise<void> => {
	try {
		await axios.put(`${BASE_URL.TRACKING}/configuration/${id}`, params);
		toaster.push(toastMessage({
			text: 'Widget configurations were saved!',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		Sentry.setTag('set-widget-config-id', id);
		sendSentryMessage({ name: `PUT Set widget config error`, context: e });
		console.log('e', e);
		// errorHandler({ e, formik });
	}
};

export const fetchCheckoutConfigurationData = async (
	dispatch: React.Dispatch<IAction>,
	mid: string,
	siteId: string,
	formik: any,
	setUploadedFile: (value: string) => void,
	setUploadedBGImage: (value: string) => void,
	setUploadedFavicon: (value: string) => void
): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_FETCH_CHECKOUT_LOADING });
		const res = await axios.get(`${BASE_URL.TRACKING}/configuration/${mid}/checkout/${siteId}`);
		if (res?.data) {
			const initialValues = convertToCheckoutInitial(res.data);
			setUploadedFile(res.data.logoFile);
			setUploadedBGImage(res.data.checkoutPageBackgroundImage);
			setUploadedFavicon(res.data.favicon);
			formik.setValues(initialValues);
			dispatch({ type: merchantActionTypes.FETCH_CHECKOUT_CONFIGURATION, payload: res.data });
		}
	} catch (e) {
		Sentry.setTag('fetch-checkout-config-siteId', siteId);
		Sentry.setTag('fetch-checkout-config-mid', mid);
		sendSentryMessage({ name: `GET Fetch checkout config error`, context: e });
		console.log('e', e);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const setCheckoutConfigurations = async (id: string, params: CheckoutFieldsReturnTypes, formik: any): Promise<void> => {
	try {
		await axios.put(`${BASE_URL.TRACKING}/configuration/${id}/checkout`, params);
		toaster.push(toastMessage({
			text: 'Checkout configurations were saved!',
			type: 'success'
		}), { placement: 'topEnd' });
	} catch (e) {
		Sentry.setTag('set-checkout-config-id', id);
		sendSentryMessage({ name: `PUT Set checkout config error`, context: e });
		console.log('e', e.response);
		errorHandler({ e, formik });
	}
};

export const setGlobalLoading = (dispatch: React.Dispatch<IAction>, loading): void => {
	dispatch({ type: merchantActionTypes.SET_GLOBAL_LOADING, payload: loading });
};

